import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Card, Button, CardContent, Image, Transition, Icon } from 'semantic-ui-react';
import i18next from 'i18next';
import { PILink } from '../nav';
import { getAssets } from '../../selectors';
import { useTransition } from '../../hooks';
import { resetCart } from '../../actions';

import './OrderTypePicker.scss';

const orderTypesIcons = {
    delivery: 'bicycle',
    takeaway: 'shopping bag',
    sitting: 'food'
};

const OrderTypePicker = () => {
    const tableNumber = useSelector(state => state.order.tableNumber);
    const orderTypes = useSelector(state => state.business.orderTypes.filter(type => !tableNumber || type !== 'delivery'));
    const visible = useTransition();
    const dispatch = useDispatch();
    const { logo, mainBackground } = useSelector(getAssets);

    function renderOrderTypeButton(orderType) {
        return (
            <Button
                key={orderType}
                className="action-btn"
                size="huge"
                as={PILink}
                replace={false}
                to={orderType === 'delivery' ? `/delivery` : `/branches`}
                params={{ orderType }}
                onClick={() => dispatch(resetCart())}
            >
                <Icon name={orderTypesIcons[orderType]} />
                {i18next.t('orderTypes.' + orderType, { context: tableNumber ? 'table' : null })}
            </Button>
        );
    }

    return (
        <div className="pi-start-order" style={{ backgroundImage: `url(${mainBackground})`, backgroundSize: 'cover' }}>
            <Transition
                animation={'scale'}
                duration={500}
                visible={visible}
            >
                <Card className="pi-container" raised>
                    <Image src={logo} className="logo" />
                    <CardContent className={`pi actions item-count-${orderTypes.length}`}>
                        {orderTypes.map(type => renderOrderTypeButton(type))}
                    </CardContent>
                </Card>
            </Transition>
        </div>
    );
};

export default OrderTypePicker;
